import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';

import * as LegalRestrictionActions from './legal-restriction.actions';
import { SiteState } from '../../shared/models';
import { LegalRestriction } from '../legal-restriction.model';
import { LegalRestrictionApiService } from '../services/legal-restriction-api.service';

@Injectable()
export class LegalRestrictionEffects {
  protected readonly store = inject<Store<SiteState>>(Store);
  protected readonly actions$ = inject(Actions);
  protected readonly legalRestrictionapi = inject(LegalRestrictionApiService);

  getLegalRestriction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LegalRestrictionActions.getLegalRestriction),
      mergeMap(({ cropId, cropAidId }) =>
        this.legalRestrictionapi.getLegalRestriction(cropAidId, cropId).pipe(
          catchError((error: HttpErrorResponse) =>
            error.status === 404
              ? of(
                  this.store.dispatch(
                    LegalRestrictionActions.setLegalRestriction({
                      legalRestriction: null,
                    }),
                  ),
                )
              : throwError(error),
          ),
          map((legalRestriction: LegalRestriction) =>
            LegalRestrictionActions.setLegalRestriction({ legalRestriction }),
          ),
        ),
      ),
    ),
  );

  getLegalRestrictions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LegalRestrictionActions.getLegalRestrictions),
      switchMap(({ cropAndCropAids }) =>
        this.legalRestrictionapi
          .getLegalRestrictions(cropAndCropAids)
          .pipe(
            map((legalRestrictions: LegalRestriction[]) =>
              LegalRestrictionActions.setLegalRestrictions({ legalRestrictions }),
            ),
          ),
      ),
    ),
  );
}
